import LivechatGame from "../components/custom/LivechatGame";
import { ConversationStep } from "../interfaces";

export default [
  {
    id: "no-worries",
    custom_value: () => {
      return {
        key: "chat_to_expert",
        value: true,
      };
    },
    type: "bot",
    message: "No worries, just need to grab a couple pieces of information. ",
    trigger: "applicant1_firstName",
  },
  {
    id: "wait-time",
    type: "bot",
    message: "Looks like the wait time is around <b>2 minutes</b>",
    wait: 120000,
    trigger: "spongebob",
  },
  {
    id: "connecting-to-exprt",
    type: "bot",
    message: "Thanks. Just connecting with the team now.",
    trigger: "wait-time",
  },
  {
    id: "spongebob",
    type: "bot",
    message:
      '<img src="https://d365pq86x330zn.cloudfront.net/81i22942-4879-41p6-6959-9i2697i72282.png" width="270" height="196" />',
    trigger: "play-a-game",
  },
  {
    id: "play-a-game",
    type: "bot",
    message: "Here’s my advice. Play a game while you wait?",
    options: [
      {
        label: "Go for it",
        value: "Go for it",
        trigger: "derby-game",
      },
      {
        label: "No thanks...",
        value: "No thanks",
        trigger: "",
      },
    ],
  },
  {
    id: "derby-game",
    type: "bot",
    component: <LivechatGame />,
    trigger: "",
  },
  {
    id: "team-exprt-away",
    type: "bot",
    message:
      "Looks like the team are away from their desk at the moment, I will shoot them an email now. I can help with letting you know what you can afford if you'd like?",
    options: [
      {
        label: "Yes",
        value: "Yes",
        trigger: "",
        action: {
          type: "resumeBotConversation",
        },
      },
      {
        label: "No",
        value: "No",
        trigger: "reaching-out-to-team",
      },
    ],
  },
  {
    id: "reaching-out-to-team",
    type: "bot",
    message: "No worries, I've asked the team to reach out to you.",
    trigger: "blank_send",
  },
] as ConversationStep[];
